import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PasswordStrengthBar from "react-password-strength-bar";
import styled from "styled-components";
import EyeOn from "../../Assets/eye-on.svg";
import EyeOff from "../../Assets/eye-off.svg";
import { logout } from "../../utils";
import Modal from "../../Container/Modal";

// -- redux
import { connect } from "react-redux";
import { ChangePasswordActions } from "../../Redux/Actions/ChangePassword";
import Loader from "../../Container/Loader";

function ChangePassword(props) {
  const [CurrentShow, setCurrentShow] = useState(false);
  const [NewShow, setNewShow] = useState(false);
  const [NewConfirmShow, setNewConfirmShow] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [SuccessMessage, setSuccessMessage] = useState("");
  const [NewPassError, setNewPassError] = useState("");
  const [ConfirmPassError, setConfirmPassError] = useState("");
  const [OpenModal, setModal] = useState(false);

  const navigate = useHistory();
  const handleModal = (e, type) => {
    e.preventDefault();
    setModal(type);
  };
  const CloseModal = (e, type) => {
    if (type === "update_password_yes") {
      handleSubmit();
      setModal(!OpenModal);
    } else {
      setModal(!OpenModal);
    }
  };
  const Image = styled.img`
    position: absolute;
    top: 55%;
    right: 15px;
  `;

  useEffect(() => {
    if (props.data && props.data.message) {
      if (props.data.status === 200) {
        setPasswordError("");
        setNewPassError("");
        setPasswordError("");
        setSuccessMessage("Password Updated! You will redirected to login page now.");
        setTimeout(() => {
          setSuccessMessage("");
          setTimeout(() => {
            logout();
          }, 1000);
        }, 4000);
      } else {
        if (props.data.message === "Invalid Password") {
          setPasswordError("Incorrect Password");
          setTimeout(() => {
            setPasswordError("");
          }, 5000);
        }
      }
    }
  }, [props.data]);

  const handleCancel = (e) => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    navigate.goBack();
  };

  const handleSubmit = () => {
    let expression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/;
    let regex = new RegExp(expression);
    if (newPassword.match(regex)) {
      if (newPassword.length < 8) {
        setNewPassError("New Password must be minimum 8 characters");
        setTimeout(() => {
          setNewPassError("");
        }, 6000);
      } else if (newPassword.length > 16) {
        setNewPassError("New Password can't have more than 16 characters");
        setTimeout(() => {
          setNewPassError("");
        }, 6000);
      } else if (newPassword !== ConfirmPassword) {
        setConfirmPassError("Passwords don't Match");
        setTimeout(() => {
          setConfirmPassError("");
        }, 5000);
      } else {
        if (currentPassword !== newPassword) {
          setPasswordError("");
          setConfirmPassError("");
          setNewPassError("");
          const data = {
            current_password: currentPassword,
            new_password: newPassword,
          };
          props.ChangePasswordActions(data);
        } else {
          setNewPassError("New Password must be different from Current Password");
          setTimeout(() => {
            setNewPassError("");
          }, 5000);
        }
      }
    } else {
      setNewPassError("New Password must have at least 1 lowercase, 1 uppercase, 1 special character, 1 numeric value");
      setTimeout(() => {
        setNewPassError("");
      }, 5000);
    }
  };

  return (
    <div className="pl-4 pr-4 change-password">
      {props.loading && <Loader />}
      <h1 className="text-white f-20 mt-5 font-weight-normal">Update your password</h1>
      {SuccessMessage && <p className="text-success m-0 f-12">{SuccessMessage}</p>}
      <p className="text-danger m-0 f-12">{}</p>
      {props &&
        props.data &&
        props.data.response &&
        props.data.response.data &&
        props.data.response.data.status === 400 &&
        props.data.response.data.data.new_password.map((item) => {
          return <p className="text-danger m-0 f-12">{item}</p>;
        })}
      <div className="mt-4 text-left mr-4">
        <label className="text-white w-50 position-relative" htmlFor="current_password">
          <p className="text-grey-6 mb-0 f-16">
            Enter Current Password <span className="text-danger">*</span>
          </p>
          <input id="current_password" type={CurrentShow ? "text" : "password"} placeholder="Current Password" className="w-100" onChange={(e) => setCurrentPassword(e.target.value)} value={currentPassword} autoComplete="off" />
          <Image onClick={() => setCurrentShow(!CurrentShow)} className="cursor-pointer" src={CurrentShow ? EyeOn : EyeOff} alt="EyeOn" />
        </label>
        {PasswordError && <p className="text-danger m-0 f-12">{PasswordError}</p>}
      </div>
      <div className="mt-4 d-flex text-left">
        <label className="text-white mr-3 w-50 position-relative" htmlFor="new_password">
          <p className="text-grey-6 mb-0 f-16">
            Enter New Password <span className="text-danger">*</span>
          </p>
          <input id="new_password" type={NewShow ? "text" : "password"} placeholder="New Password" className="w-100" onChange={(e) => setNewPassword(e.target.value)} value={newPassword} autoComplete="off" />
          <Image onClick={() => setNewShow(!NewShow)} className="cursor-pointer" src={NewShow ? EyeOn : EyeOff} alt="EyeOn" />
          <PasswordStrengthBar password={newPassword} scoreWordStyle={{ display: "none" }} minLength={4} barColors={["#646464", "#FF3B30", "#f6b44d", "#00FF6A", "#00FF6A"]} />
          {NewPassError && <p className="text-danger m-0 f-12">{NewPassError}</p>}
        </label>
        <label className="text-white w-50 ml-3 position-relative" htmlFor="new_password">
          <p className="text-grey-6 mb-0 f-16">
            Confirm New Password <span className="text-danger">*</span>
          </p>
          <input id="new_password" type={NewConfirmShow ? "text" : "password"} placeholder="Confirm New Password" className="w-100" onChange={(e) => setConfirmPassword(e.target.value)} value={ConfirmPassword} autoComplete="off" />
          <Image onClick={() => setNewConfirmShow(!NewConfirmShow)} className="cursor-pointer" src={NewConfirmShow ? EyeOn : EyeOff} alt="EyeOn" />
          {ConfirmPassError && <p className="text-danger m-0 f-12">{ConfirmPassError}</p>}
        </label>
      </div>
      <div className="mt-5 d-flex justify-content-between">
        <button
          className="form-button pl-5 pr-5"
          // disabled={(currentPassword.length === 0 && newPassword.length === 0 && ConfirmPassword.length === 0)}
          onClick={(e) => handleCancel(e)}
        >
          Cancel
        </button>
        <button onClick={(e) => handleModal(e, "update_password")} className="form-button" disabled={!(currentPassword && newPassword && ConfirmPassword)}>
          Save
        </button>
      </div>
      {OpenModal && <Modal Name={""} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
    </div>
  );
}

const mapStateToProps = ({ ChangePasswordReducer }) => {
  const { loading, data } = ChangePasswordReducer;
  return { loading, data };
};

const mapDispatchToProps = {
  ChangePasswordActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
